import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';

import './SearchNav.css';

class SearchNav extends Component {
  render() {
    const basePath = '/search';
    const currentPath = this.props.currentPath;

    return (
      <div className="SearchNav">
          <div>
          <p>This search tool has been developed with a focus on the food industry and is 
            based on FSANZ standards for food labelling, including providing information 
            on nutrient content claims. You can also search by nutrient to find the best 
            sources of particular nutrients or to guide product formulation.
          </p>
          <p>
            New from 2026 – There are 602 new or updated Food Records
          </p>
          <p>
            For further details about the data, please refer to the New Zealand Food Composition Database 2026 Data Manual.
          </p>
              <br/>
          </div>
        <DesktopNav basePath={basePath} currentPath={currentPath} />
        <MobileNav basePath={basePath} currentPath={currentPath} pre />
        {this.props.children &&
          <div className="SearchContent">
            {this.props.children}
          </div>
        }
        <MobileNav basePath={basePath} currentPath={currentPath} />
      </div>
    );
  }
}

SearchNav.propTypes = {
  location: PropTypes.object,
  currentPath: PropTypes.string,
  children: PropTypes.element,
};

export default SearchNav;



// WEBPACK FOOTER //
// ./src/components/search/searchNav/SearchNav.js